var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{attrs:{"input-value":_vm.accepted},on:{"change":_vm.handleChange},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._v("\n    I accept the "),_c('terms-and-conditions-link')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }